import { get } from 'lodash';
import { useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import type { OnChangeSetting } from 'hb-builder/types/settings';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import { validateUrlAndMailToFormat } from 'hb-react/shared/utils/validators/urlFormat';

import RadioLinkInput from '../ComposedInputs/RadioLinkInput';

export interface ButtonLinkProps {
  item: DocumentItem;
  onChange: OnChangeSetting;
  placeholder?: string;
  withToolTipDescription?: string | boolean;
}

const ButtonLink = ({
  item,
  onChange,
  placeholder,
  withToolTipDescription,
}: ButtonLinkProps) => {
  const [value, setValue] = useState(get(item.attributes, 'buttonLink'));

  const handleChange = ({ value: inputValue }) => {
    if (inputValue !== value && (inputValue || value)) {
      setValue(inputValue || '');

      // If the link starts with a / then it's an internal link and we don't need to validate the format and start with http://
      const errorUrlProtocol =
        !inputValue?.startsWith('/') &&
        validateUrlAndMailToFormat(inputValue, true);

      const formattedUrl = errorUrlProtocol
        ? `http://${inputValue}`
        : inputValue;

      onChange({
        id: item.id,
        settingKey: 'attributes.buttonLink',
        value: formattedUrl,
      });
    }
  };

  return (
    <Wrapper data-testid="setting-button-link">
      <RadioLinkInput
        id={`buttonSettingsContentLink${item.id}`}
        label={__('Link')}
        onChange={handleChange}
        placeholder={placeholder}
        value={value}
        withToolTipDescription={withToolTipDescription}
      />
    </Wrapper>
  );
};

export default ButtonLink;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 4,
}))``;
